<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Payment/Settlement History
        <div class="card-header-actions">
          <button class="btn btn-danger mr-1" @click="close()"><i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="8">
          <b-form-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>Invoice Number</label></b-input-group-prepend>
                <b-form-input v-model="model.invoiceno" readonly></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>Invoice Date</label></b-input-group-prepend>
                <b-form-input v-model="model.invdate" type="date" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-form-row>
          <b-input-group>
            <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
            <b-form-input readonly v-model="model.custinfo"></b-form-input>
          </b-input-group>
          <b-form-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>Sales Order No.</label></b-input-group-prepend>
                <b-form-input readonly v-model="model.ordernumber"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                <b-form-radio-group class="mt-2" v-model="model.proforma" name="radioProforma" disabled>
                  <b-form-radio value="0">Actual Invoice</b-form-radio>
                  <b-form-radio value="1">Proforma (PBB) Invoice</b-form-radio>
                </b-form-radio-group>
              </b-input-group>
            </b-col>
          </b-form-row>
          <b-input-group>
            <b-input-group-prepend><label>Description Line#1</label></b-input-group-prepend>
            <b-form-input v-model="model.uraian1" readonly></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Description Line#2</label></b-input-group-prepend>
            <b-form-input v-model="model.uraian2" readonly></b-form-input>
          </b-input-group>
          <b-form-row>
            <b-col cols="6">
              <b-input-group>
                <b-input-group-prepend><label>Invoice Amount</label></b-input-group-prepend>
                <b-input-group-prepend
                  ><span class="input-group-text" style="width: 60px">{{ model.matauang }}</span></b-input-group-prepend
                >
                <my-number class="form-control text-right" separator="," v-model="model.totalinv" :precision="2" readonly></my-number>
              </b-input-group>
            </b-col>
            <b-col cols="6">
              <b-input-group>
                <b-input-group-prepend><label>Related to other Invoice #</label></b-input-group-prepend>
                <b-form-input v-model="model.invoicereff" readonly=""></b-form-input>
              </b-input-group>
            </b-col>
          </b-form-row>
        </b-col>
        <b-col lg="4">
          <v-dim :model="model" :key="updateDimHdr"></v-dim>
        </b-col>
      </b-row>
      <b-card no-body class="mb-1">
        <div class="report-wraper">
          <table style="width: 100%">
            <thead>
              <tr>
                <th width="80px">Settlement Date</th>
                <th width="110px">Doc. Number</th>
                <th width="110px">Settlement Method</th>
                <th>Description</th>
                <th width="90px">Input By</th>
                <th width="140px" style="text-align: right">Credit</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in rptLines" :key="row.tablekey">
                <td :class="row.kelas">{{ row.tanggal | moment("DD MMM YYYY") }}</td>
                <td :class="row.kelas">{{ row.nomor }}</td>
                <td :class="row.kelas">{{ row.paymethod }}</td>
                <td :class="row.kelas">{{ row.uraian }}</td>
                <td :class="row.kelas">{{ row.createby }}</td>
                <td :class="row.kelas" style="text-align: right">{{ row.nilaibayar | numFormat }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
      <b-row class="mt-1">
        <b-col lg="8">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>Outstanding Status </label></b-input-group-prepend>
                <b-form-select v-model="model.ostStatuskey" :plain="true" :options="ostandStatus"></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><span class="p-2">Collector</span></b-input-group-prepend>
                <b-form-input v-model="model.collector"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend><label>Collection Note</label></b-input-group-prepend>
            <b-form-input v-model="model.colleNote"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
            <button class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Update Status</button>
          </b-input-group>
        </b-col>
        <b-col lg="4">
          <div class="text-right">
            <b-input-group>
              <b-input-group-prepend><label style="text-align: left; width: 158px; padding-left: 16px">Total Settlement</label></b-input-group-prepend>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{ model.matauang }}</span>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.totalsettle" :precision="2" disabled></my-number>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend><label style="text-align: left; width: 158px; padding-left: 16px">Outstanding</label></b-input-group-prepend>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{ model.matauang }}</span>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.outstand" :precision="2" disabled></my-number>
            </b-input-group>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<style lang="scss">
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 130px;
    }
  }
}
.form-group {
  margin-bottom: 2px;
  .input-group {
    padding-bottom: 0;
  }
}
.row-details-form {
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
  .input-group {
    .input-group-prepend {
      label {
        width: 110px !important;
      }
    }
  }
}
.report-wraper {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;

  table {
    font-size: smaller;
    th {
      border-bottom: 1px solid #d1d1d1;
      padding: 0 15px;
      height: 30px;
      background: #e8e8e8;
    }
    td {
      border-bottom: 1px solid #f5f5f5;
      padding: 0 10px;
      height: 25px;
    }

    td.tebal {
      font-weight: bold;
    }

    td.payment {
      font-style: italic;
      background-color: rgba(0, 0, 0, 0.05) !important;
    }

    td.subtotal {
      border-top: 2px solid #000 !important;
    }

    td.total {
      border-top: 2px solid #000 !important;
      background: #e6e6e6 !important;
      height: 40px;
    }

    td.grdtotal {
      border-top: 2px solid #000 !important;
      border-bottom: 2px double #000 !important;
      background: #e6e6e6 !important;
    }
    tbody tr:hover {
      background-color: rgba(91, 192, 222, 0.2) !important;
      cursor: default;
    }
  }
}
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import vDim from "../lookup/dimReadonly";
import arinv from "../../apis/arinv";
toastr.init();

export default {
  components: { myNumber, vDim },
  data() {
    return {
      horizontal: true,
      updateDimHdr: false,
      uanguser: this.$store.state.user.matauang,
      ostandStatus: [{ value: "", text: "" }],
      model: { custcode: "", ordernumber: "", kodecash: "", proforma: 0, nilaippn: 0, nofaktur: "", tglfaktur: "", DimTableKey: "", ttlgross: "", ttlamtdue: "" },
      rptLines: [],
    };
  },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function () {
    if (this.$route.params.arinvKey) {
      toastr.info("Loading ARDetail, please wait");
      try {
        const [d, data] = await Promise.all([arinv.outstandstatus(), await arinv.detailsettle(this.$route.params)]);
        this.ostandStatus = this.ostandStatus.concat(d);

        // const data = await arinv.detail(this.$route.params);
        const row = data[0][0];
        row.invdate = row.invdate ? moment(row.invdate).format("YYYY-MM-DD") : "";
        row.duedate = row.duedate ? moment(row.invduedate).format("YYYY-MM-DD") : "";
        for (var key in row) {
          this.model[key] = row[key];
        }
        this.rptLines = data[1];
        this.calcTotalDtl();
        this.updateDimHdr = !this.updateDimHdr;
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      this.close();
    }
  },
  methods: {
    save: async function () {
      // if (this.invalidModel) {
      //     console.log('validation : ', this.$v.model);
      //     console.log('model obj : ',this.model);
      //     toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      // } else {
      this.isLoading = true;
      try {
        const response = await arinv.updatecollect(this.model);
        this.isLoading = false;
        this.close();
      } catch (error) {
        this.isLoading = false;
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else {
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
      // }
    },
    calcTotalDtl: function () {
      let totalsettle = 0;
      this.rptLines.forEach(function (trx) {
        totalsettle += trx.nilaibayar || 0;
      });
      this.model.totalsettle = totalsettle;
    },
    close() {
      toastr.info("back to list");
      if (this.$store.state.prevRoute.name && this.$store.state.prevRoute.name !== "receivable.arinvpayview") {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        // router.push({name:'payable.arinv'});
        router.push("home");
      }
    },
  },
};
</script>
